// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_State from "../Control.Monad.State/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Spelled from "../Data.Pitches.Spelled/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Halogen_HTML_Properties from "../Halogen.HTML.Properties/index.js";
import * as ProtoVoices_Folding from "../ProtoVoices.Folding/index.js";
import * as ProtoVoices_Model from "../ProtoVoices.Model/index.js";
import * as Pruning from "../Pruning/index.js";
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Pitches_Class.showPitch(Data_Pitches_Spelled.notationPitchSInterval));
var member = /* #__PURE__ */ Data_Map_Internal.member(Data_Ord.ordInt);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_State_Trans.applicativeStateT(Data_Identity.monadIdentity));
var bindStateT = /* #__PURE__ */ Control_Monad_State_Trans.bindStateT(Data_Identity.monadIdentity);
var bind = /* #__PURE__ */ Control_Bind.bind(bindStateT);
var monadStateStateT = /* #__PURE__ */ Control_Monad_State_Trans.monadStateStateT(Data_Identity.monadIdentity);
var get = /* #__PURE__ */ Control_Monad_State_Class.get(monadStateStateT);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(bindStateT);
var put = /* #__PURE__ */ Control_Monad_State_Class.put(monadStateStateT);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(Data_Ord.ordInt);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var bind1 = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var ix = /* #__PURE__ */ Foreign_Index.ix(/* #__PURE__ */ Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(/* #__PURE__ */ Foreign_Index.indexString(Data_Identity.monadIdentity));
var readBoolean = /* #__PURE__ */ Foreign.readBoolean(Data_Identity.monadIdentity);
var readNumber = /* #__PURE__ */ Foreign.readNumber(Data_Identity.monadIdentity);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordInt);
var Init = /* #__PURE__ */ (function () {
    function Init() {

    };
    Init.value = new Init();
    return Init;
})();
var NoOp = /* #__PURE__ */ (function () {
    function NoOp() {

    };
    NoOp.value = new NoOp();
    return NoOp;
})();
var Select = /* #__PURE__ */ (function () {
    function Select(value0) {
        this.value0 = value0;
    };
    Select.create = function (value0) {
        return new Select(value0);
    };
    return Select;
})();
var Forward = /* #__PURE__ */ (function () {
    function Forward() {

    };
    Forward.value = new Forward();
    return Forward;
})();
var Backward = /* #__PURE__ */ (function () {
    function Backward() {

    };
    Backward.value = new Backward();
    return Backward;
})();
var ToFirst = /* #__PURE__ */ (function () {
    function ToFirst() {

    };
    ToFirst.value = new ToFirst();
    return ToFirst;
})();
var ToLast = /* #__PURE__ */ (function () {
    function ToLast() {

    };
    ToLast.value = new ToLast();
    return ToLast;
})();
var RegisterScoreElt = /* #__PURE__ */ (function () {
    function RegisterScoreElt(value0) {
        this.value0 = value0;
    };
    RegisterScoreElt.create = function (value0) {
        return new RegisterScoreElt(value0);
    };
    return RegisterScoreElt;
})();
var ToggleSettings = /* #__PURE__ */ (function () {
    function ToggleSettings() {

    };
    ToggleSettings.value = new ToggleSettings();
    return ToggleSettings;
})();
var ToggleInner = /* #__PURE__ */ (function () {
    function ToggleInner() {

    };
    ToggleInner.value = new ToggleInner();
    return ToggleInner;
})();
var ToggleOuter = /* #__PURE__ */ (function () {
    function ToggleOuter() {

    };
    ToggleOuter.value = new ToggleOuter();
    return ToggleOuter;
})();
var ToggleScore = /* #__PURE__ */ (function () {
    function ToggleScore() {

    };
    ToggleScore.value = new ToggleScore();
    return ToggleScore;
})();
var ToggleSurface = /* #__PURE__ */ (function () {
    function ToggleSurface() {

    };
    ToggleSurface.value = new ToggleSurface();
    return ToggleSurface;
})();
var SetXScale = /* #__PURE__ */ (function () {
    function SetXScale(value0) {
        this.value0 = value0;
    };
    SetXScale.create = function (value0) {
        return new SetXScale(value0);
    };
    return SetXScale;
})();
var SetYScale = /* #__PURE__ */ (function () {
    function SetYScale(value0) {
        this.value0 = value0;
    };
    SetYScale.create = function (value0) {
        return new SetYScale(value0);
    };
    return SetYScale;
})();
var showExplanation = function (v) {
    if (v instanceof ProtoVoices_Model.NoExpl) {
        return "unexplained";
    };
    if (v instanceof ProtoVoices_Model.RootExpl) {
        return "root note";
    };
    if (v instanceof ProtoVoices_Model.DoubleExpl) {
        var ornStr = (function () {
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.FullNeighbor) {
                return "full neighbor";
            };
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.FullRepeat) {
                return "full repeat";
            };
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.LeftRepeatOfRight) {
                return "left repeat";
            };
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.RightRepeatOfLeft) {
                return "right repeat";
            };
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.PassingMid) {
                return "middle passing note";
            };
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.PassingLeft) {
                return "left passing note";
            };
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.PassingRight) {
                return "right passing note";
            };
            if (v.value0.orn instanceof Data_Maybe.Nothing) {
                return "unexplained";
            };
            throw new Error("Failed pattern match at Common (line 93, column 16 - line 101, column 33): " + [ v.value0.orn.constructor.name ]);
        })();
        return ornStr + (" between " + (show(v.value0.leftParent.pitch) + (" and " + show(v.value0.rightParent.pitch))));
    };
    if (v instanceof ProtoVoices_Model.RightExpl) {
        var ornStr = (function () {
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.RightRepeat) {
                return "repeat";
            };
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.RightNeighbor) {
                return "neighbor";
            };
            if (v.value0.orn instanceof Data_Maybe.Nothing) {
                return "ornament (unexplained)";
            };
            throw new Error("Failed pattern match at Common (line 106, column 16 - line 109, column 44): " + [ v.value0.orn.constructor.name ]);
        })();
        return "right " + (ornStr + (" of " + show(v.value0.leftParent.pitch)));
    };
    if (v instanceof ProtoVoices_Model.LeftExpl) {
        var ornStr = (function () {
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.LeftRepeat) {
                return "repeat";
            };
            if (v.value0.orn instanceof Data_Maybe.Just && v.value0.orn.value0 instanceof ProtoVoices_Model.LeftNeighbor) {
                return "neighbor";
            };
            if (v.value0.orn instanceof Data_Maybe.Nothing) {
                return "ornament (unexplained)";
            };
            throw new Error("Failed pattern match at Common (line 114, column 16 - line 117, column 44): " + [ v.value0.orn.constructor.name ]);
        })();
        return "left " + (ornStr + (" of " + show(v.value0.rightParent.pitch)));
    };
    if (v instanceof ProtoVoices_Model.HoriExpl) {
        return "spread from " + show(v.value0.pitch);
    };
    throw new Error("Failed pattern match at Common (line 88, column 19 - line 120, column 57): " + [ v.constructor.name ]);
};
var noteIsSelected = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Just && v1 instanceof ProtoVoices_Model.Inner) {
            return v.value0.note.id === v1.value0.id;
        };
        return false;
    };
};
var fillCache = function (model) {
    return function (step) {
        return function (cache) {
            var insertItem = function (f) {
                return function (place) {
                    var $64 = member(step)(place);
                    if ($64) {
                        return pure(place);
                    };
                    return bind(get)(function (savedMPruned) {
                        return bind((function () {
                            if (savedMPruned instanceof Data_Maybe.Nothing) {
                                var mp = Pruning.pruneModel(step)(model);
                                return discard(put(new Data_Maybe.Just(mp)))(function () {
                                    return pure(mp);
                                });
                            };
                            if (savedMPruned instanceof Data_Maybe.Just) {
                                return pure(savedMPruned.value0);
                            };
                            throw new Error("Failed pattern match at Common (line 139, column 18 - line 145, column 27): " + [ savedMPruned.constructor.name ]);
                        })())(function (mpruned) {
                            if (mpruned instanceof Data_Either.Left) {
                                return pure(place);
                            };
                            if (mpruned instanceof Data_Either.Right) {
                                return pure(insert(step)(f(mpruned.value0))(place));
                            };
                            throw new Error("Failed pattern match at Common (line 146, column 7 - line 148, column 54): " + [ mpruned.constructor.name ]);
                        });
                    });
                };
            };
            return Data_Function.flip(Control_Monad_State.evalState)(Data_Maybe.Nothing.value)(bind(insertItem(identity)(cache.modelPruned))(function (pruned$prime) {
                return bind(insertItem((function () {
                    var $76 = ProtoVoices_Folding.evalGraph(true)(true);
                    return function ($77) {
                        return $76((function (v) {
                            return v.reduction;
                        })($77));
                    };
                })())(cache.graph))(function (graph$prime) {
                    return bind(insertItem((function () {
                        var $78 = ProtoVoices_Folding.findSurface(false);
                        return function ($79) {
                            return $78((function (v) {
                                return v.reduction;
                            })($79));
                        };
                    })())(cache.surface))(function (surface$prime) {
                        return pure({
                            modelPruned: pruned$prime,
                            graph: graph$prime,
                            surface: surface$prime
                        });
                    });
                });
            }));
        };
    };
};
var emptyCache = {
    modelPruned: Data_Map_Internal.empty,
    graph: Data_Map_Internal.empty,
    surface: Data_Map_Internal.empty
};
var defaultSettings = {
    flatHori: true,
    xscale: 0.0,
    yscale: 0.0,
    showSettings: false,
    showInner: false,
    showOuter: false,
    showScore: true,
    showSurface: true
};
var readOptions = function (obj) {
    return {
        flatHori: Data_Either.fromRight(defaultSettings.flatHori)(Control_Monad_Except.runExcept(bind1(ix(obj)("flatHori"))(readBoolean))),
        xscale: Data_Either.fromRight(defaultSettings.xscale)(Control_Monad_Except.runExcept(bind1(ix(obj)("xscale"))(readNumber))),
        yscale: Data_Either.fromRight(defaultSettings.yscale)(Control_Monad_Except.runExcept(bind1(ix(obj)("yscale"))(readNumber))),
        showSettings: Data_Either.fromRight(defaultSettings.showSettings)(Control_Monad_Except.runExcept(bind1(ix(obj)("showSettings"))(readBoolean))),
        showInner: Data_Either.fromRight(defaultSettings.showInner)(Control_Monad_Except.runExcept(bind1(ix(obj)("showInner"))(readBoolean))),
        showOuter: Data_Either.fromRight(defaultSettings.showOuter)(Control_Monad_Except.runExcept(bind1(ix(obj)("showOuter"))(readBoolean))),
        showScore: Data_Either.fromRight(defaultSettings.showScore)(Control_Monad_Except.runExcept(bind1(ix(obj)("showScore"))(readBoolean))),
        showSurface: Data_Either.fromRight(defaultSettings.showSurface)(Control_Monad_Except.runExcept(bind1(ix(obj)("showSurface"))(readBoolean)))
    };
};
var class_ = function (str) {
    return Halogen_HTML_Properties.class_(str);
};
var cacheGetSurface = function (mpruned) {
    return function (step) {
        return function (cache) {
            var v = lookup(step)(cache.surface);
            if (v instanceof Data_Maybe.Just) {
                return v.value0;
            };
            if (v instanceof Data_Maybe.Nothing) {
                return ProtoVoices_Folding.findSurface(false)(mpruned.reduction);
            };
            throw new Error("Failed pattern match at Common (line 161, column 38 - line 163, column 49): " + [ v.constructor.name ]);
        };
    };
};
var cacheGetPruned = function (model) {
    return function (step) {
        return function (cache) {
            var v = lookup(step)(cache.modelPruned);
            if (v instanceof Data_Maybe.Just) {
                return new Data_Either.Right(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Pruning.pruneModel(step)(model);
            };
            throw new Error("Failed pattern match at Common (line 151, column 35 - line 153, column 35): " + [ v.constructor.name ]);
        };
    };
};
var cacheGetGraph = function (mpruned) {
    return function (step) {
        return function (cache) {
            var v = lookup(step)(cache.graph);
            if (v instanceof Data_Maybe.Just) {
                return v.value0;
            };
            if (v instanceof Data_Maybe.Nothing) {
                return ProtoVoices_Folding.evalGraph(true)(true)(mpruned.reduction);
            };
            throw new Error("Failed pattern match at Common (line 156, column 36 - line 158, column 51): " + [ v.constructor.name ]);
        };
    };
};
export {
    class_,
    Init,
    NoOp,
    Select,
    Forward,
    Backward,
    ToFirst,
    ToLast,
    RegisterScoreElt,
    ToggleSettings,
    ToggleInner,
    ToggleOuter,
    ToggleScore,
    ToggleSurface,
    SetXScale,
    SetYScale,
    defaultSettings,
    readOptions,
    noteIsSelected,
    showExplanation,
    emptyCache,
    fillCache,
    cacheGetPruned,
    cacheGetGraph,
    cacheGetSurface
};
